@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.notificationdata
import com.narbase.letsgo.dto.core.KmmLong

data class DriverLocationAndPriceDto(
    val driver_lat: Double,
    val driver_lng: Double,
    val driver_bearing: Float? = null,
    val price: Int,
    val discount: Int,
    val ride_id: KmmLong?,
)